export default "__VITE_PUBLIC_ASSET__d829f435__"